<script lang="ts">
	import { t } from '$i18n/i18n.ts'
	import StaticChipList from '../organisms/StaticChipList.svelte'
	import { writable, type Writable } from 'svelte/store'
	import { LotType } from '../types/enums'
	import { getContext, hasContext } from 'svelte'
	import { whitelistModalUtils } from './whitelistModalUtil'

	export let lotTypes: LotType[] = []
	// context stores
	let selectedLotTypes: Writable<(string | LotType)[]> = hasContext('selectedLotTypes')
		? getContext('selectedLotTypes')
		: writable([])

	let lotTypesChipOptions: {
		label: string
		value: LotType
		msg: string
		showOnCreate: boolean
	}[]

	// lotTypes are given from config data -> all LotTypes for which materials exist
	$: lotTypesChipOptions = lotTypes.map((flag) => ({
		label: whitelistModalUtils.getLotTypeStringResource(flag as LotType),
		value: flag as LotType,
		msg: whitelistModalUtils.getLotTypeTTipMsg(flag as LotType),
		showOnCreate: flag === LotType.TRANSPORT
	}))
</script>

<div class="whitelist-view-header">
	<span>{$t('UI.whitelist.modal.startpage.chiplist.header')}</span>
</div>
<StaticChipList
	bind:activeChips={$selectedLotTypes}
	list={lotTypesChipOptions}
	identifier="whitelist-lot-types"
	header=""
	showSelectAll
/>

<style>
	div.whitelist-view-header {
		padding-bottom: 0.7rem;

		& > span {
			font-family: Roboto, sans-serif;
			font-style: normal;
			font-size: var(--font-size, 0.75rem);
			font-weight: var(--font-weight, 500);
			line-height: var(--line-height, 1rem);
			color: var(--color, black);
		}
	}
</style>
